module.exports = __webpack_public_path__ + "static/media/creme.358102cb.jpg";